
import { Injectable } from '@angular/core';

import { HttpClient } from './../http-client';
import { Config } from '../local/config';
import { UserData } from '../local/user-data';



/*
  Generated class for the AuthProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class AuthProvider {


  constructor(public http: HttpClient,
    public userData: UserData,
    public config: Config) {
    console.log('Hello AuthProvider Provider');
  }

  login(user: string, password: string) {

    if(this.config.get('DISABLE_API')) {
      return Promise.resolve({ acces_token: 123});
    }

    let link = `${this.config.get('BASE_API')}/${this.userData.sede}/token`;
    /*let data = {
      grant_type: 'password',
      username: user,
      password: password
    };*/
    let data = `grant_type=password&username=${user}&password=${password}`;

    return this.http.post(link, data)
    .then((res: any) => {
      if(res.status == 'success' && res.data) {
        this.userData.userToken = res.data.access_token;
        return this.currentUser();
      }
      return res;
    });
  }


  currentUser() {
    if(this.config.get('DISABLE_API')) {
      return Promise.resolve({ acces_token: 123, userName: true});
    }

    let link = `${this.config.get('BASE_API')}/${this.userData.sede}/api/users/current`;

    return this.http.get(link, 1)
    .then((res: any) => {
      //console.log('Current User',res);
      if(res.status == 'success' && res.data && res.data.userName) {
        this.userData.user = res.data;
      }
      return res;
    });

  }

  checkLogin() {
    return this.currentUser().then((res: any) => {
      return res && res.data && res.data.userName? true : false;
    });
  }

  logout() {
    //return this.registerDeviceToken('').then((res: any) => {
      this.userData.user = null;
      this.userData.userToken = null;
      return Promise.resolve({ status: 'success', data: true });
    //});
    
    
   
  }

  registerDeviceToken(token) {
    if(!this.userData.userToken) {
      token = '';
    }
    let link = `${this.config.get('BASE_API')}/${this.userData.sede}/api/users/deviceToken`;
    return this.http.post(link, { deviceToken: token }, 1);
  }

  

}



// WEBPACK FOOTER //
// C:/projects/angular/DineroAgil/src/app/providers/auth/auth.ts